import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
	deleteDraftInvoice,
	fetchInvoiceDetails,
	updateInvoiceStatus,
} from '../../../../../services/invoices';
import useInvoice from './useInvoice';
import { useSelector } from 'react-redux';
const UseInvoiceDetails = () => {
	const param = useParams();
	const id = param?.id;
	const navigate = useNavigate();
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const { handlePrintAndDownloadPdf } = useInvoice();
	const suburl = localStorage.getItem('suburl');
	const [invoiceDetails, setInvoiceDetails] = useState([]);
	const [updateStatus, setUpdateStatus] = useState(null);
	const [isUpdateStatusModelOpen, setUpdateStatusModelOpen] = useState(false);
	const [isVoidStatusModelOpen, setIsVoidStatusModelOpen] = useState(false);
	const [isShareLinkModelOpen, setShareLinkModelOpen] = useState(false);
	const [isRecordPaymentModalOpen, setIsRecordPaymentModalOpen] = useState(false);
	const [isDeleteInvoiceModelOpen, setIsDeleteInvoiceModalOpen] = useState(false);
	const [loader, setLoader] = useState({
		isLoading: false,
		status: null,
	});
	const location = useLocation();

	async function generateSalesInvoicesPdf(type = 'print', merge = false) {
		try {
			await handlePrintAndDownloadPdf(id, type, merge);
		} catch (error) {}
	}

	async function handleVoidStatus(status) {
		try {
			await updateInvoiceStatus(id, status);
			toast.success('Status Updated Successfully');
			navigate(`/user/${suburl}/invoices`);
		} catch (error) {
			toast.error(error?.message ?? 'Sometning went wrong!');
		}
	}

	async function handleUpdateStatus() {
		try {
			await updateInvoiceStatus(id, updateStatus);
			toast.success('Status Updated Successfully');
			navigate(`/user/${suburl}/invoices`);
		} catch (error) {
			toast.error(error?.message ?? 'Sometning went wrong!');
		}
	}

	async function handleDeleteInvoice() {
		try {
			const res = await deleteDraftInvoice(id);
			if (res.success) {
				toast.success(res.message || 'Something went wrong!');
				navigate(`/user/${suburl}/invoices`);
			} else {
				toast.error(res.message || 'Something went wrong!');
			}
			setIsDeleteInvoiceModalOpen(false);
		} catch (error) {
			toast.error(error?.message ?? 'Sometning went wrong!');
		}
	}

	async function getInvoiceDetails(isModelOpen = false) {
		try {
			setLoader((prev) => ({
				...prev,
				isLoading: true,
				status: 'detail',
			}));
			const body = {
				ids: [id],
			};
			var { invoice } = await fetchInvoiceDetails(body);
			setInvoiceDetails(invoice);
			if (isModelOpen && location && location?.state && location.state?.isOpen) {
				setIsRecordPaymentModalOpen(true);
			}
		} catch (error) {
			toast.error('Something went wrong!');
		} finally {
			setLoader((prev) => ({
				...prev,
				isLoading: false,
				loaderId: 'detail',
			}));
		}
	}
	useEffect(() => {
		if (id) {
			getInvoiceDetails(true);
		}
	}, [id]);
	return {
		user,
		id,
		loader,
		suburl,
		navigate,
		invoiceDetails,
		generateSalesInvoicesPdf,
		setUpdateStatus,
		setUpdateStatusModelOpen,
		isUpdateStatusModelOpen,
		handleUpdateStatus,
		handleVoidStatus,
		handleDeleteInvoice,
		setIsVoidStatusModelOpen,
		isVoidStatusModelOpen,
		isShareLinkModelOpen,
		setShareLinkModelOpen,
		isRecordPaymentModalOpen,
		setIsRecordPaymentModalOpen,
		setIsDeleteInvoiceModalOpen,
		isDeleteInvoiceModelOpen,
		getInvoiceDetails,
	};
};
export default UseInvoiceDetails;
